export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n4_appartenance-verticale.dac57046.svg";